export default __webpack_public_path__ + "39ed320c585f2bdb68e5705823a476ba.png";